let pageExiting = false;

const markPageExiting = () => {
  pageExiting = true;
};

if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', markPageExiting, { once: true });
  window.addEventListener('pagehide', markPageExiting, { once: true });
}

export const isPageExiting = () =>
  pageExiting || (typeof document !== 'undefined' && document.visibilityState === 'hidden');

export const isPageExitFetchAbort = (error: unknown) => {
  if (!isPageExiting() || !(error instanceof TypeError)) {
    return false;
  }

  return /failed to fetch|load failed|networkerror/i.test(error.message);
};
